import React from 'react';
import {
  useGetAllBlockUnblockDataQuery,
  useGetBlockScopesQuery,
} from '../../../services/blockUnblockRetailer';
import { skipToken } from '@reduxjs/toolkit/query';
import {
  TBlockScope,
  TBlockUnblockRetailerData,
} from '../../../utils/types';
import './index.scss';
import * as yup from 'yup';
import { AutoCompleteController } from '../../../components';
import { toTitleCase } from '../../../utils/functions/string';
import { useFormWithSchema } from '../../../utils/functions/yupFormTypescript';
import { useAuthHelper } from '../../../utils/functions/authentication';
import { BlockUnblockAction } from './blockUnblockAction';
import { AdditionalDetails } from './additionalDetails';
import { BlockUnblockDetailsTable } from './blockUnblockDetailsTable';

const formSchema = yup.object({
  blockScope: yup
    .mixed<TBlockScope>()
    .required('Please Select Category'),
});

export const BlockUnblockDetails: React.FC<{
  blockUnblockDetails: TBlockUnblockRetailerData;
  readOnly: boolean;
}> = ({ blockUnblockDetails }) => {
  const {
    control,
    formState: { errors },
    watch,
  } = useFormWithSchema(formSchema, {
    mode: 'onTouched',
  });
  const blockScope = watch('blockScope');
  const {
    data: allBlockUnblockData,
    isLoading: isAllBlockUnblockDataLoading,
  } = useGetAllBlockUnblockDataQuery(
    (blockScope
      ? {
          blockScope,
          retailerId: blockUnblockDetails.retailerId,
        }
      : undefined) ?? skipToken
  );
  const { data: blockScopes } = useGetBlockScopesQuery();
  const { checkPageAccess } = useAuthHelper();
  const hasEditAccess = checkPageAccess(
    'BLOCK_UNBLOCK_RETAILER_EDIT'
  );

  return (
    <div className="pt-8">
      <div className="grid grid-cols-2 gap-x-20">
        <div>
          <div className="details-label">Retailer Name</div>
          <div> {blockUnblockDetails.name}</div>
        </div>
        <div>
          <div className="details-label">Mobile Number</div>
          <div> {blockUnblockDetails.mobile}</div>
        </div>
      </div>
      <div className="flex items-center justify-between pt-7">
        <div className="w-80">
          <AutoCompleteController
            control={control}
            label="Category"
            name="blockScope"
            options={blockScopes?.map((ele) => ({
              value: ele,
              label: toTitleCase(ele).replaceAll('_', ' '),
            }))}
            error={errors.blockScope?.message}
            required
          />
        </div>
        <div className="mt-3">
          {hasEditAccess && !!blockScope && (
            <BlockUnblockAction
              blockScope={blockScope}
              blockUnblockDetails={
                allBlockUnblockData?.data[0]
              }
            />
          )}
          {blockScope === 'POINT_REDEEM_BLOCK' && (
            <AdditionalDetails
              retailerId={blockUnblockDetails.retailerId}
            />
          )}
        </div>
      </div>
      {blockScope && (
        <BlockUnblockDetailsTable
          allBlockUnblockData={allBlockUnblockData}
          isListDataLoading={isAllBlockUnblockDataLoading}
        />
      )}
    </div>
  );
};
